import { isEmpty } from 'lodash';
import {
    Icon,
    cssVar,
    Box,
    Text,
    Popover,
    PopoverTrigger,
    PopoverContent,
    DataList,
    DataItem,
} from '@cad-arc';
import { MatchingCriteriaPerson } from '@mark43/cad-api';
import { formatDate } from '../../../../../common/helpers/utils';

export const MatchingCriteriaPersonPopover = ({
    criteria,
}: {
    criteria?: MatchingCriteriaPerson;
}) => {
    if (criteria === undefined || isEmpty(criteria)) {
        return <></>;
    }

    const { driversLicenseNumber, name, dateOfBirth, phoneNumber, location, involvement } =
        criteria;

    return (
        <Popover>
            <PopoverTrigger asChild>
                <Icon
                    icon="Information"
                    aria-label="matching criteria"
                    style={{ color: cssVar('arc.colors.brand.default'), cursor: 'pointer' }}
                    data-testid="MATCHING_CRITERIA_PERSON_POPOVER_TRIGGER"
                />
            </PopoverTrigger>
            <PopoverContent>
                <Text variant="headingXs">Matching Criteria</Text>
                <Box
                    fontSize="sm"
                    marginTop="3"
                    maxWidth={268}
                    data-testid="MATCHING_CRITERIA_PERSON_POPOVER_CONTENT"
                >
                    <DataList variant="inline" spacing="1">
                        {driversLicenseNumber && (
                            <DataItem dataKey="DL">{driversLicenseNumber}</DataItem>
                        )}
                        {name && <DataItem dataKey="Name">{name}</DataItem>}
                        {dateOfBirth && (
                            <DataItem dataKey="DOB">{formatDate(dateOfBirth)}</DataItem>
                        )}
                        {phoneNumber && <DataItem dataKey="Phone Number">{phoneNumber}</DataItem>}
                        {location && <DataItem dataKey="Location">{location}</DataItem>}
                        {involvement && <DataItem dataKey="Involvement">{involvement}</DataItem>}
                    </DataList>
                </Box>
            </PopoverContent>
        </Popover>
    );
};
